import type { FC, ReactNode } from 'react';
import React from 'react';
import { InfoBox } from '@THC/components/InfoBox';

import { ModalBody } from '../ModalBody';
import type { ModalEnquiryListGroupsProps } from '../ModalEnquiryList';
import { ModalEnquiryListGroups } from '../ModalEnquiryList';
import { ModalHeader } from '../ModalHeader';

import styles from './ModalListErrors.module.scss';

interface ModalListErrorsProps {
	groups: ModalEnquiryListGroupsProps['groups'];
	headerDescription: ReactNode;
	headerTitle: ReactNode;
	infoBoxDescription: ReactNode;
	infoBoxTitle: ReactNode;
}

export const ModalListErrors: FC<ModalListErrorsProps> = ({
	groups,
	headerDescription,
	headerTitle,
	infoBoxDescription,
	infoBoxTitle,
}) => (
	<>
		<ModalHeader description={headerDescription} title={headerTitle} />
		<ModalBody className={styles.errorsBody}>
			<InfoBox content={infoBoxDescription} heading={infoBoxTitle} size="small" variant="error" />
			<ModalEnquiryListGroups groups={groups} />
		</ModalBody>
	</>
);
